import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    createLinearStepper,
    ILinearStepperProperties,
    IStaticStepItem,
} from '@vfde-brix/ws10/linear-stepper';
import { AppHtmlId } from '../enums/elementId';
import { getStepperData } from '../util/cms';

/**
 *
 * @param {string[]} stepsLabels - Array of step labels to be displayed in the stepper
 * @param {number} [activeStep=4] - The currently active step, starting from 4
 * @throws will throw an error if stepsLabel is empty or if activeStep is out of bounds
 *
 */
export const mountLinearStepper = () => {

    const { stepsLabels, activeStep } = getStepperData();

    // Validate stepsLabels array
    if (!stepsLabels || 0 === stepsLabels.length) {
        throw new Error('The stepsLabel array must contain at least one step');
    }

    // Validate activeStep be within the bounds of stepsLabels array
    if (1 > activeStep || activeStep >= stepsLabels.length) {
        throw new Error(`The activeStep must be between 1 and ${stepsLabels.length - 1}`);
    }

    const stepperSteps: IStaticStepItem[] = stepsLabels.map(
        (stdTextLabel, i) => ({
            stdId: `${AppHtmlId.LINEAR_STEPPER}-${i}`,
            stdTextLabel,
        }),
    );

    const props: ILinearStepperProperties = {
        stepperSteps,
        optDynamicStepperSteps: false,
        business: NO_PATTERN_BUSINESS_LOGIC,
        optActiveStep: activeStep,
    };

    return createComponentById(createLinearStepper, AppHtmlId.LINEAR_STEPPER, props);
};




